import { gql } from '@apollo/client';

const COPY_AI_REPORT_MUTATION = gql`
  mutation copyAiReport($input: CopyAiReportInput!) {
    copyAiReport(input: $input) {
      isSuccess
      message
    }
  }
`;

export default COPY_AI_REPORT_MUTATION;
